/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LikeDto } from '../../models/like-dto';

export interface LikeControllerUnLiked$Params {
  id: string;
}

export function likeControllerUnLiked(http: HttpClient, rootUrl: string, params: LikeControllerUnLiked$Params, context?: HttpContext): Observable<StrictHttpResponse<LikeDto>> {
  const rb = new RequestBuilder(rootUrl, likeControllerUnLiked.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LikeDto>;
    })
  );
}

likeControllerUnLiked.PATH = '/api/like/{id}';
